export const sealOfSilence = {
  key: 'seal_of_silence',
  name: 'Seal of Silence',
  category: 'curse',
  description: 'A letter is sealed away and will not answer at first.',
};
